<template>
  <div>
    <app-table
      ref="app-table"
      :is-current-page="false"
      :page-size="2000"
      :table-props="{ 'max-height': '450px' }"
      :table-key="table_key"
      :table-list-data="table_data"
    />
    <el-dialog
      v-if="dialog_config.is_show"
      :title="dialog_config.title"
      :visible.sync="dialog_config.is_show"
      :before-close="dialog_config.cancel"
      :close-on-click-modal="false"
      :append-to-body="true"
      :modal-append-to-body="true"
      width="800px"
    >
      <app-form
        v-if="dialog_config.is_show"
        ref="app-form"
        v-loading="dialog_config.is_loading"
        :form-data="dialog_config.form_config"
        @confirm="dialog_config.confirm"
        @cancel="dialog_config.cancel"
      />
    </el-dialog>
  </div>
</template>

<script>
import { CHANNEL_INTERFACE_TYPE } from '@/enums';
import { addStoryComponentApi, getStoryComponentButtonListApi } from '@/api/tool/story-component';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-form': () => import('@/components/app-form'),
  },
  props: {
    // 表单项配置
    formItem: {
      type: Object,
      required: true,
    },
    // 初始化数据
    initOps: {
      type: Object,
      required: true,
    },
    // 数据表
    dataMap: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // 表头配置
      table_key: require('./model/table-key.js')(this),
      // 表格数据
      table_data: [],
      // 弹窗配置
      dialog_config: {
        is_show: false,
        is_loading: false,
        title: '',
        row: {},
        form_config: {},
        confirm: () => {},
        cancel: () => {},
      },
    };
  },
  computed: {
    advertiser_ids() {
      const { advertiser_ids } = this.initOps;
      return advertiser_ids;
    },
  },
  created() {
    if (Object.keys(this.formItem.value.result_map).length) {
      this.edit();
    } else {
      this.generateTableData();
    }
  },
  methods: {
    /**
     * 生成表格数据
     * @returns {void}
     */
    generateTableData() {
      const data = this.advertiser_ids.map(advertiser_id => {
        return {
          advertiser_id,
          type: { options: this.formItem.value.type_selection, value: '' },
          target: { ...this.initTarget() },
        };
      });
      this.table_data.push(...data);
    },
    /**
     * 编辑
     * @returns {void}
     */
    edit() {
      const data = Object.entries(this.formItem.value.result_map).map(([key, value]) => {
        return {
          advertiser_id: key,
          type: {
            options: this.formItem.value.type_selection,
            value: value.type,
          },
          target: {
            ...this.initTarget(),
            [value.type]: {
              options: value.options,
              value: value.value,
            },
          },
        };
      });
      this.table_data.push(...data);
    },
    /**
     * 获取目标配置
     * @param {string} type 目标类型
     * @param {Object} row 表格行数据
     * @param {Boolean} is_reset_value 是否重置值
     * @returns {void}
     */
    getTargetConfig(type, row, is_reset_value = true) {
      this.dataMap[type]?.(row.advertiser_id, type)?.then(res => {
        Object.assign(row.target[type], {
          options: res,
          ...(is_reset_value && { value: '' }),
        });
      });
    },
    /**
     * 初始化目标
     * @returns {Object}
     */
    initTarget() {
      const target = {};
      this.formItem.value.type_selection.forEach(({ value }) => {
        Object.assign(target, {
          [value]: {
            options: [],
            value: '',
          },
        });
      });
      return target;
    },
    /**
     * 新建Story转化组件
     * @param {Object} row 当前行数据
     * @returns {void}
     */
    async onAddStoryComponent(row) {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '新建Story转化组件',
        row,
        form_config: require('./model/form-config.js')(this),
        confirm: (params) => {
          const { component_name, component_type, image_url, button_id, ...rest } = params;
          const { button_id: button_id_filed } = this.dialog_config.form_config;
          const { advertiser_id } = this.dialog_config.row;

          const button_id_option = button_id_filed.options.find(({ value }) => button_id === value);

          const payload = {
            channel_interface: CHANNEL_INTERFACE_TYPE.BILIBILI,
            advertiser_id,
            component_name,
            component_type,
            common: {
              image_url: image_url.url,
              button_id,
              button_text: button_id_option.label,
              button_type: button_id_option.button_type,
              ...rest,
            },
          };

          addStoryComponentApi(payload).then(({ message }) => {
            this.$message.success(message || '新建成功！');
            this.dialog_config.is_show = false;
            const { row } = this.dialog_config;
            this.getTargetConfig(row.type.value, row, false);
          });
        },
        cancel: () => {
          this.dialog_config.is_show = false;
        },
      });

      const { advertiser_id, type } = row;
      const { component_type, button_id } = this.dialog_config.form_config;

      component_type.value = type.value;
      button_id.options = await this.getStoryComponentButtonList({
        channel_interface: CHANNEL_INTERFACE_TYPE.BILIBILI,
        advertiser_id,
        bilibili_params: { filtering: { component_type: type.value }},
      });
    },
    /**
     * 查询Story创意组件可用按钮
     * @param {Object} params 请求参数
     * @return {Promise<Object[]>}
     */
    async getStoryComponentButtonList(params) {
      try {
        const { list = [] } = await getStoryComponentButtonListApi(params);
        const result = list.map(({ button_id, button_text, ...rest }) => ({ label: button_text, value: button_id, ...rest }));
        return result;
      } catch (error) {
        throw error;
      }
    },
  },
};
</script>
